// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75ce1b44","524":"b9e51b46","529":"8c036114","545":"eef11525","947":"b66539dd"}[chunkId] + ".chunk.js";
};